import React from 'react'
import {Button} from 'reactstrap'

// props correct, checkClick
export default class Check extends React.Component {
    render(){
        var{correct}=this.props;//select ?
        if(correct!=null){ //Evaluated
            if( correct=== true ) return (<Button size="lg" color="success">Correct</Button>);
            else return (<Button size="lg" color="danger">Incorrect</Button>);
        }
        else return (
            <Button className="text-center" size="lg" color="primary" onClick={()=>this.props.checkClick()}>
                Check!
            </Button>
        
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Check.js